import { postAny, remove } from "../Api";
import {
  EFrequencyPaymentType,
  EMaintenanceType,
  getFirstImage,
  ProductSubscription
} from "../Product/ProductSubscriptionApi";

export interface QuoteSubscriptionForm {
  productId: string;
  productCode: string;
  name: string;
  description: string;
  highLevelDescription?: string;
  highlights?: string[];
  classification?: string;
  imageUrl?: string;
  price: number;
  stripePriceId: string;
  quantity: number;
  vatRate?: number;
  maintenanceType: EMaintenanceType;
  paymentType: EFrequencyPaymentType;
}

export const mapProductSubscriptionToForm = (item: ProductSubscription): QuoteSubscriptionForm => {
  return {
    productId: item.id,
    productCode: item.code,
    imageUrl: getFirstImage(item)?.url,
    ...item,
    price: item.prices[0].price,
    paymentType: item.prices[0].paymentType,
    stripePriceId: item.prices[0].stripePriceId,
    classification: item.classification.code
  };
};

export async function addSubscription(quoteId: string, request: QuoteSubscriptionForm) {
  return postAny<QuoteSubscriptionForm>(`store/quote/subscription/${quoteId}`, request);
}

export async function removeSubscription(quoteId: string, request: QuoteSubscriptionForm) {
  return remove(`store/quote/subscription/${quoteId}/product/${request.productId}`);
}
